import { render, staticRenderFns } from "./GreenBubble.vue?vue&type=template&id=356a6580&scoped=true"
import script from "./GreenBubble.vue?vue&type=script&lang=js"
export * from "./GreenBubble.vue?vue&type=script&lang=js"
import style0 from "./GreenBubble.vue?vue&type=style&index=0&id=356a6580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356a6580",
  null
  
)

export default component.exports